/* import __COLOCATED_TEMPLATE__ from './usage-drawer.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

interface Signature {
  Args: {
    model: {
      selectedUsageReminderType?: string;
      onOpenChange: (open: boolean) => void;
      open: boolean;
    };
    appId: string;
  };
}

export default class UsageDrawer extends Component<Signature> {
  @service declare appService: AppService;
  @service declare router: any;

  get appId() {
    return this.appService.app.id;
  }

  @action
  onNavigateToBillingSettings() {
    if (this.args.model?.onOpenChange) {
      this.args.model.onOpenChange(false);
    }
    this.router.transitionTo('apps.app.settings.subscription.billing.settings');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Usage::UsageDrawer': typeof UsageDrawer;
    'billing/usage/usage-drawer': typeof UsageDrawer;
  }
}
